module.exports = "<div>\n    <div ng-repeat=\"item in enquiriesProgress.list\"\n        ng-if=\"item.isActive || enquiriesProgress.display =='all'\">\n        <enquiry-progress\n            vehicle-id=\"enquiryDetails.vehicleId\"\n            enquiry-id=\"enquiryDetails.lastEnquiryId\"\n            notes=\"enquiryDetails.notes\"\n            details=\"item\"\n        ></enquiry-progress>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./Client/app/tasks/directives/enquiriesProgress/enquiries-progress.html
// module id = 684
// module chunks = 0